import { render } from "./itemIndex.vue?vue&type=template&id=dc15adf4"
import script from "./itemIndex.vue?vue&type=script&lang=js"
export * from "./itemIndex.vue?vue&type=script&lang=js"

import "./itemIndex.vue?vue&type=style&index=0&id=dc15adf4&lang=scss"

import exportComponent from "D:\\新建文件夹\\workPage\\OA H5\\stgd.oa.mobile.h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__